module.exports = __webpack_public_path__ + "img/internet-box-mixed-tile.e95eb6f8.png";